import React from 'react';
import { ImportPatientCreateTemplate } from 'themes/application/import/pages';
import { observer } from 'mobx-react';
import { ImportPatientCreateViewStore } from 'application/import/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ImportPatientCreateViewStore(rootStore), 'editView')
@observer
class ImportPatientCreate extends React.Component {
    render() {
        return <ImportPatientCreateTemplate {...this.props} />
    }
}

export default ImportPatientCreate;